export default {"src":"/_next/static/media/person-icon.b3eb0bb8.svg","height":65,"width":64,"blurWidth":0,"blurHeight":0};